import { trpc } from '@/shared/api/trpc';

// Initialization status drives the "Initialize Organization" trigger.
// Gated by `enabled` (system-role only) so non-system users never fire it.
export const useOrganizationInitStatus = (enabled: boolean) =>
  trpc.organizationInit.status.useQuery(undefined, {
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
